import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { DialogData } from 'src/app/core/models/dialogs.model';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-dialog-component',
  template: `
    @if (data['title']) {
      <h2 mat-dialog-title>
        @if (isWarning) {
          <fa-icon [icon]="warningIcon" class="warning-icon"></fa-icon>
        }
        {{ data['title'] }}
      </h2>
    }
    <mat-dialog-content [innerHTML]="message"></mat-dialog-content>
    <mat-dialog-actions>
      @if (data.buttons.cancel) {
        <button mat-button mat-dialog-close>
          {{ data['buttons']['cancel']['text'] | titlecase }}
        </button>
      }

      @if (data.buttons.confirm) {
        <button mat-button [mat-dialog-close]="true">
          {{ data['buttons']['confirm']['text'] | titlecase }}
        </button>
      }
    </mat-dialog-actions>
  `,
  styleUrls: ['./dialog.component.scss'],
  imports: [
    CommonModule,
    MatDialogModule,
    FaIconComponent,
    MatButton
  ]
})
export class DialogComponent {
  message = '';

  warningIcon: IconDefinition = faExclamationTriangle;
  isWarning = false;

  constructor(public dialogRef: MatDialogRef<DialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.isWarning = data['isWarning'] ? data['isWarning'] : false;
    if (!data['message'].startsWith('<')) {
      this.message = '<p>' + data['message'] + '</p>';
    } else {
      this.message = data['message'];
    }
  }

  clicked(evt: any) {
    this.dialogRef.close(true);
  }
}
